// src/components/LoaderPanel.jsx
import React, { useEffect, useState } from 'react';
import './style/LoaderPanel.css';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { TbWorldWww } from 'react-icons/tb';

const LoaderPanel = ({ progress, status, onClose, type, errorMsg }) => {
  const [autoClose, setAutoClose] = useState(false);

  useEffect(() => {
    if (status === 'success' || status === 'error') {
      const timer = setTimeout(() => {
        setAutoClose(true);
        onClose(); // auto fermeture
      }, 7000);
      return () => clearTimeout(timer);
    }
  }, [status, onClose]);

  const getSuccessMsg = () => {
    if (type === 'image') return "Merci ! Votre photo a bien été envoyée.";
    if (type === 'comment') return "Merci ! Votre message a bien été envoyé.";
    return "Merci ! Contenu envoyé avec succès.";
  };

  return (
    <div className="upload-loader-overlay">
      <div className="upload-loader-panel">
        {status === 'loading' && (
          <>
            <div className="upload-loader-circle">
              <svg viewBox="0 0 36 36">
                <path
                  className="circle-bg"
                  d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className="circle"
                  strokeDasharray={`${progress}, 100`}
                  d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0 -31.831"
                />
              </svg>
              <div className="upload-loader-text">{progress}%</div>
            </div>
            <p>Envoi en cours...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="upload-loader-check" aria-hidden="true">✔</div>
            <p className="upload-success-text">{getSuccessMsg()}</p>

            <div className="upload-support-bloc">
              <span className="upload-support-title">Soutenez-nous :</span>
              <div className="upload-loader-socials">
                <a
                  href="https://www.instagram.com/be.on.wall/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="upload-social-link"
                  aria-label="Instagram BeOnWall"
                  title="Instagram BeOnWall"
                >
                  <FaInstagram aria-hidden="true" />
                </a>
                <a
                  href="https://www.tiktok.com/@beonwall?lang=fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="upload-social-link"
                  aria-label="TikTok BeOnWall"
                  title="TikTok BeOnWall"
                >
                  <FaTiktok aria-hidden="true" />
                </a>
                <a
                  href="https://www.beonwall.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="upload-social-link"
                  aria-label="Site web BeOnWall"
                  title="Site web BeOnWall"
                >
                  <TbWorldWww aria-hidden="true" />
                </a> 
              </div>
            </div>

            <button className="upload-loader-button" onClick={onClose}>OK</button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="upload-loader-error" aria-hidden="true">✖</div>
            <p>{errorMsg ? errorMsg : "Une erreur est survenue"}</p>
            <button className="upload-loader-button" onClick={onClose}>OK</button>
          </>
        )}
      </div>
    </div>
  );
};

export default LoaderPanel;
